import React from 'react';

/**
 * Footer cell for pinnedBottomRowData. Renders nothing by default; consumers
 * pass `format(value, row)` to produce the display string.
 *
 * cellRendererParams (merged with column.cellProps):
 *   format(value, row) => ReactNode   formatter; falls back to plain value
 *   prefixLabel  string|null           optional inline label
 *   bold         boolean               default true
 */
function TotalsFooterCell(params) {
  const { value, data, format, prefixLabel, bold = true } = params;
  if (value === undefined || value === null || value === '') return null;
  const rendered = typeof format === 'function' ? format(value, data) : value;
  return (
    <span className={bold ? 'cag-totals-cell cag-totals-cell--bold' : 'cag-totals-cell'}>
      {prefixLabel ? `${prefixLabel} ` : null}
      {rendered}
    </span>
  );
}

export default TotalsFooterCell;
